import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';
import { THERAPIST_ROUTES_PREFIX } from '../therapist-planning/therapist-planning.path';

export const PROPOSE_FOLLOW_UP_PATH = `${THERAPIST_ROUTES_PREFIX}/propose-follow-up`;

export const ProposeFollowUpLoadable = loadable(async () => import('./propose-follow-up.view'), {
  fallback: <FullPageLoading />,
});
